import './MainFeatureError.less';
import Button from '../../button/Button';
import { useTranslation } from '../../../hooks/useTranslation';
import errorImageSrc from '../../../img/error.svg';

export type MainFeatureErrorProps = {
    imageSrc?: string;
    title?: string;
    subtitle?: string;
    retryButtonLabel?: string;
    onRetryClick?: () => void;
};

const MainFeatureError = ({
    imageSrc = errorImageSrc,
    title,
    subtitle,
    retryButtonLabel,
    onRetryClick
}: MainFeatureErrorProps) => {
    const { t } = useTranslation();
    return (
        <div className={`bri-MainFeatureError`}>
            <img className={`bri-MainFeatureError-image`} src={imageSrc} />
            <div className={`bri-MainFeatureError-main `}>
                <div className={`bri-MainFeatureError-text `}>
                    <span className={`bri-TitleBoldFont`}>
                        {title ?? t('GENERIC_ERROR_TITLE')}
                    </span>
                    <span className={`bri-BodyLargeFont`}>
                        {subtitle ?? t('GENERIC_ERROR_SUBTITLE')}
                    </span>
                </div>
                {onRetryClick && (
                    <Button variant="primary" onClick={onRetryClick}>
                        {retryButtonLabel ??
                            t('GENERIC_ERROR_RETRY_BUTTON_LABEL')}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default MainFeatureError;
